import React from 'react';
import { Badge } from '@chakra-ui/react';

const SOURCE_LABELS = {
	client_portal: 'Client upload',
	staff: 'Staff',
};

const ContactSourceBadge = ({ source, size = 'sm', ...badgeProps }) => {
	const key = source === 'client_portal' ? 'client_portal' : 'staff';
	const isClient = key === 'client_portal';

	return (
		<Badge
			colorScheme={isClient ? 'purple' : 'gray'}
			variant={isClient ? 'subtle' : 'outline'}
			borderRadius='full'
			fontSize={size === 'xs' ? '2xs' : 'xs'}
			textTransform='none'
			{...badgeProps}>
			{SOURCE_LABELS[key]}
		</Badge>
	);
};

export default ContactSourceBadge;
